'use client'

import WorkspaceAiChatPageClient from './WorkspaceAiChatPageClient'

export default function WorkspaceAiChatPageLoader() {
  return <WorkspaceAiChatPageClient />
}
